import { RequestKind, boolean, number, string } from '@sb/library/base';
import { CashAttachmentDisplayItem, CashDeleteOptions, CashDisplayItem, CashInputItem, CashSearchOptions, CashSummarySearchOptions, CashUpdateItem, DisplayItemCollection, OCRReceiptDisplayItem, OCRReceiptInputItem, PayeeDisplayItem, PayeeSearchOptions } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace CashRoutes {
    export const Add = ApiRoute.Define({
        URL: 'cash',
        Kind: RequestKind.Post,
        BodyType: CashInputItem,
        ResultType: Array<string>
    });

    export const Search = ApiRoute.Define({
        URL: `search/cash`,
        Kind: RequestKind.Post,
        BodyType: CashSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<CashDisplayItem>
    });

    export const Delete = ApiRoute.Define({
        URL: (cashID: string) => `cash/${cashID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean,
        BodyType: CashDeleteOptions
    });

    export const GetAll = ApiRoute.Define({
        URL: `cash`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<CashDisplayItem>
    });

    export const Get = ApiRoute.Define({
        URL: (cashID: string) => `cash/${cashID}`,
        Kind: RequestKind.Get,
        ResultType: CashDisplayItem
    });

    export const Update = ApiRoute.Define({
        URL: (cashID: string) => `cash/${cashID}`,
        Kind: RequestKind.Put,
        BodyType: CashUpdateItem,
        ResultType: Array<string>
    });

    export const GetSummary = ApiRoute.Define({
        URL: 'summary/cash/sum',
        Kind: RequestKind.Post,
        BodyType: CashSummarySearchOptions,
        ResultType: number
    });

    export namespace Payees {
        export const Get = ApiRoute.Define({
            URL: 'payees',
            Kind: RequestKind.Get,
            ResultType: Array<PayeeDisplayItem>
        });

        export const Search = ApiRoute.Define({
            URL: 'search/payees',
            Kind: RequestKind.Post,
            BodyType: PayeeSearchOptions,
            ResultType: Array<PayeeDisplayItem>,
            RequestedFieldsType: PayeeDisplayItem,
        });
    }

    export namespace Attachments {
        export const Add = ApiRoute.Define({
            URL: (cashID: string) => `cash/${cashID}/attachments`,
            Kind: RequestKind.Post,
            BodyType: FormData
        });

        export const Delete = ApiRoute.Define({
            URL: (attachmentID: string) => `cashattachments/${attachmentID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });

        export const GetAll = ApiRoute.Define({
            URL: (cashID: string) => `cash/${cashID}/attachment`,
            Kind: RequestKind.Get,
            ResultType: DisplayItemCollection<CashAttachmentDisplayItem>
        });
    }

    export namespace Receipt {
        export const ProcessOCR = ApiRoute.Define({
            URL: 'receiptimages',
            Kind: RequestKind.Post,
            BodyType: FormData,
            ResultType: OCRReceiptDisplayItem
        });

        export const Attach = ApiRoute.Define({
            URL: (receiptGUID: string) => `receiptimages/${receiptGUID}`,
            Kind: RequestKind.Post,
            BodyType: OCRReceiptInputItem,
            ResultType: string
        });
    }
}
